/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, {
  useState,
  Children,
} from 'react';
import PropTypes from 'prop-types';
import useStyle from './style';
import cx from '@/utils/cx';

const List = ({
  children,
  className,
  highlightable,
  onItemSelect,
  ...rest
}) => {
  const classes = useStyle();
  const [highlighted, setHighlighted] = useState(0);

  const listItems = Children.toArray(children)
    .filter((child) => child && child.type && child.type.name);

  const handleKeyDown = (event) => {
    if (!highlightable) {
      return;
    }
    event.preventDefault();
    if (event.keyCode === 40) { // down
      setHighlighted(highlighted === listItems.length - 1 ? 0 : highlighted + 1);
    } else if (event.keyCode === 38) { // up
      setHighlighted(highlighted === 0 ? listItems.length - 1 : highlighted - 1);
    }
  };

  const handleClick = (index) => (event) => {
    // eslint-disable-next-line no-unused-expressions
    event && event.preventDefault();

    if (event && event.type === 'keyup' && event.keyCode !== 13) return;

    if (highlightable) {
      setHighlighted(index);
    }
    onItemSelect(listItems[index].props, index);
    if (listItems[index].props.onSelect) {
      listItems[index].props.onSelect(listItems[index].props, index);
    }
  };

  return (
    <ul
      className={cx(classes.list, className)}
      tabIndex="0"
      onKeyDown={handleKeyDown}
      onKeyUp={handleClick(highlighted)}
      {...rest}
    >
      {listItems.map((child, index) => (
        <child.type
          {...child.props}
          index={index}
          key={`list-item-${index + 1}`}
          highlighted={highlightable ? highlighted : -1}
          onClick={handleClick(index)}
        />
      ))}
    </ul>
  );
};

List.propTypes = {
  onItemSelect: PropTypes.func,
  highlightable: PropTypes.bool,
  className: PropTypes.string,
};

List.defaultProps = {
  className: '',
  onItemSelect: () => {},
  highlightable: true,
};

export default List;
